export * from './getGroup';
export * from './groupingFunc';
export * from './groupSettings';
export * from './ngTableDefaultGetGroups';


// WEBPACK FOOTER //
// ./~/angular1-template-loader!./src/core/grouping/index.ts